import moment from "moment";
import {
  PHONE_NUMBER_PATTERN,
  UNIREG_PHONE_NUMBER_PATTERN
} from "../../resource/regexp-patterns";
import { DEFAULT_DOB_FORMAT } from "../../utils/constants";

export const UNIREG_MASK_KEY = "UNI_REG";

export const masks = {
  PhoneNumber: {
    hasNesting: true,
    UNI_REG: {
      mask: "999-999-9999",
      maskChar: "",
      pattern: UNIREG_PHONE_NUMBER_PATTERN
    },
    default: {
      mask: "(999) 999-9999",
      maskChar: "",
      pattern: PHONE_NUMBER_PATTERN
    }
  },

  Number: {
    mask: "9999999999",
    maskChar: ""
  },

  DateOfBirth: {
    hasNesting: true,
    USA: {
      mask: "99/99/9999",
      maskChar: "_",
      placeholder: "MM/DD/YYYY",
      pattern: /^(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/
    },
    CAN: {
      mask: "99/99/9999",
      maskChar: "",
      placeholder: "MM/DD/YYYY",
      pattern: /^(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/
    },
    DNK: {
      mask: "9999-99-99",
      maskChar: "_",
      placeholder: "YYYY-MM-DD",
      pattern: /^(19|20)\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
    },
    GBR: {
      mask: "99/99/9999",
      maskChar: "",
      placeholder: "DD/MM/YYYY",
      pattern: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/
    },
    default: {
      mask: "99/99/9999",
      maskChar: "",
      placeholder: "MM/DD/YYYY",
      pattern: /^(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/
    }
  },

  Month: {
    mask: "99",
    maskChar: "",
    placeholder: "MM"
  },

  Year: {
    mask: "9999",
    maskChar: "",
    placeholder: "YYYY"
  },

  CreditCardExpDate: {
    mask: "99/99",
    maskChar: "",
    placeholder: "MM/YY"
  }
};

export const unmasks = {
  PhoneNumber: maskedValue => maskedValue.replace(/[^0-9]/g, ""),
  CreditCard: maskedValue => maskedValue.replace(/[^0-9]/g, ""),
  DateOfBirth: (maskedValue, locale) => {
    const mask = masks.DateOfBirth[locale] || masks.DateOfBirth.default;

    return moment(maskedValue, mask.placeholder).format(DEFAULT_DOB_FORMAT);
  }
};
